export default __webpack_public_path__ + "static/media/cbr3.fc58f328.PNG";